export default __webpack_public_path__ + "static/DesktopMediaMainBanner-5a49a80ecea4ac2c3a6c0a4b7ae7c093.png";